import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {FilterRecordButton} from "../buttons/FilterRecordButton.tsx";

const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>, <FilterRecordButton key='filter'/>];

    if (allowedActions.includes('DeleteApplication')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('CreateApplication')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Applications')}
            tools={useTools()}
        />
    );
};
